const ShopButton = {
  parts: [
    'shopButton',
    'shopIcon'
  ],
  baseStyle: {
    shopButton: {
      display: 'flex',
      p: 3, // 12px
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2.5, // 10px
      borderRadius: 'base', // 4px
      bg: 'linear-gradient(0deg, rgba(110, 87, 87, 0.1) 0%, rgba(255, 255, 255, 0.10) 100%), rgba(27, 26, 24, 0.30)',
      backdropFilter: 'blur(10px)',
      cursor: 'pointer',
      color: 'white',
      _hover: {
        bg: 'linear-gradient(0deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.20) 100%), rgba(27, 26, 24, 0.40)',
      },
      transition: 'background 0.2s ease',
    },
    shopIcon: {
      width: 5, // 20px
      height: 5, // 20px
      display: 'flex',
      sx: {
        ' svg': {
          width: '100%',
          height: '100%',
        },
      },
    },
    shopButtonText: {
      color: 'white',
      textAlign: 'center',
      fontSize: 'xs',
      fontStyle: 'normal',
      fontWeight: 'medium',
      lineHeight: '110%',
      whiteSpace: 'nowrap',
      display: {base: 'none', md: 'flex'},
    },
  },
};

export default ShopButton;
